<template>
  <div>
    <v-row class="mx-0">
      <v-col cols="12" class="pa-0" v-if="!hideDivider">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="auto" class="my-auto">
        <user-avatar
          :size="80"
          :user="recognition.createdBy"
          cssClass="mr-n2 on-top"
        ></user-avatar>
      </v-col>
      <v-col class="my-auto secondarytext--text">
        <v-row dense>
          <v-col cols="12">
            <v-chip
              :color="getColor($vuetify.theme.themes.light.primary, 0.1)"
              v-if="recognition.coreValueName"
              class="pl-0"
            >
              <v-img
                v-if="recognition.badgeUrl"
                :src="recognition.badgeUrl"
                width="30"
              ></v-img>
              <span class="ml-2 primary--text">
                {{ recognition.coreValueName }}
              </span>
            </v-chip>
          </v-col>
          <v-col cols="12">
            {{ recognition.text }}
          </v-col>
          <v-col cols="auto" class="caption">
            By: {{ recognition.createdBy.fullName }}
          </v-col>
          <v-col cols="auto" class="caption">
            Date: {{ recognition.createdDate | longDate }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RecognitionLineItem",
  components: {},
  props: {
    recognition: { type: Object },
    hideDivider: { type: Boolean, default: false }
  },
  data: () => ({}),
  watch: {},
  computed: {
    ...mapGetters({ profile: "profile/profile" })
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.on-top {
  z-index: 100;
}
</style>
